import React, { useEffect, useState } from 'react';
import {
  Box, Grid, TextField, Button, Divider, Stepper, StepLabel, Step, stepConnectorClasses,
  StepConnector, Typography, MenuItem, useTheme, useMediaQuery, Snackbar, Alert
} from '@mui/material';
import CustomStepIcon from '../form-stepper/CustomStepIcon';
import AuthService from '../Auth/AuthService';
import { getAcademicYear } from '../utils/academicYear';

const steps = ['Basic Info', 'Parent Info', 'Last Academic Info'];

const form1 = [
  { label: 'First Name', name: 'firstName' },
  { label: 'Last Name', name: 'lastName' },
  { label: 'Gender', name: 'gender' },
  { label: 'Date of Birth', name: 'dateOfBirth', type: 'date' },
  { label: 'Aadhaar Number', name: 'aadhaarNumber' },
  { label: 'Apaar Number/id', name: 'apaarNumber', req: false },
  { label: 'Current Address line1', name: 'address' },
  { label: 'City', name: 'city' },
  { label: 'State', name: 'state' },
  { label: 'Country', name: 'country' },
  { label: 'Pincode', name: 'pincode' },
  { label: 'Mother Tongue', name: 'motherTongue' },
  { label: 'Where Stay', name: 'stayType' },
];

const form2 = [
  { label: 'Mobile/Phone', name: 'phone' },
  { label: 'Father Name', name: 'fatherName' },
  { label: 'Father Education', name: 'fatherEducation, req: false' },
  { label: 'Mother Name', name: 'motherName' },
  { label: 'Mother Education', name: 'motherEducation', req: false },
  { label: 'Guardian Name', name: 'guardianName', req: false },
  { label: 'Religion', name: 'religion' },
  { label: 'Category', name: 'category' },
  { label: 'Caste', name: 'caste' },
  { label: 'Annual Income', name: 'annualIncome', req: false },
  { label: 'Any Relative in school', name: 'anyRelativeIn', req: false },
  { label: 'Parmanent Address', name: 'parmanentAddress' },
];

const form3 = [
  { label: 'Study Medium', name: 'medium' },
  { label: 'Academic Year', name: 'academicYear' },
  { label: 'Standard', name: 'standard' },
  { label: 'Section', name: 'section' },
  { label: 'Last School', name: 'lastSchool', req: false },
  { label: 'Result', name: 'result' },
  { label: 'Leave of Reason', name: 'leaveOfReason', req: false },
  { label: 'Pattern', name: 'patternType' },
  { label: 'Transport', name: 'transport', req: false },
  { label: 'Admission Date', name: 'admissionDate', type: 'date', req: false },
];

const StudentRegister = ({ initialData = {}, onSuccess, onSubmit }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [academicYear, setAcademicYear] = useState("");
  const [pages, setPages] = useState(0);
  const [error, setError] = useState(null);
  const userInfo = AuthService.tokenInfo();
  const [student, setStudent] = useState({
    id: "",
    firstName: '',
    lastName: '',
    gender: '',
    dateOfBirth: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    stayType: '',
    aadhaarNumber: '',
    apaarNumber: '',
    motherTongue: '',
    fatherName: '',
    fatherEducation: '',
    motherName: '',
    motherEducation: '',
    guardianName: '',
    annualIncome: '',
    religion: '',
    caste: '',
    anyRelativeIn: '',
    parmanentAddress: '',
    classRoomDTO: {
      admissionDate: "",
      standard: "",
      section: "",
      lastSchool: '',
      medium: '',
      leaveOfReason: '',
      result: '',
      transport: '',
      annualFee: '',
      patternType: '',
      academicYear: academicYear
    },
    isActive: true,
    createdBy: '',
    ...initialData
  });
  const [feesStructures, setFeesStructures] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    setStudent((prev) => ({ ...prev, ...initialData, classRoomDTO: { ...initialData?.classRoom[0] } }));
    setAcademicYear(getAcademicYear(new Date()));
    fetchFeesStructures();
  }, [initialData]);

  const fetchFeesStructures = async () => {
    try {
      const url = AuthService.pathUrl('GET', '/fees/structure')
      const response = await AuthService.getAuth(url);
      if (response.length === 0) {
        if (onSuccess) onSuccess(
          setSnackbar({
            open: true,
            message: `Please add the fee structure first before adding students.`,
            severity: 'warning',
          }));
        return;
      }
      setFeesStructures(response);
    } catch (error) {
      console.error("Error fetching fees structures:", error);
    }
  };

  const regex = {
    mobile: /^[6-9]\d{9}$/,              // 10-digit Indian mobile
    aadhaar: /^\d{12}$/,                 // 12-digit Aadhaar/apaar
    pincode: /^\d{6}$/,                  // 6-digit pincode
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // basic email
    gender: /^(MALE|FEMALE|OTHER)$/i,     // allowed options
    pattern: /^(STATE|CBSE|ICSE)$/i,    // allowed options
    academicyear: /^2\d{3}-2\d{3}$/  // matches 2000-2999 only
  };

  const isRequired = (field) => field.req !== false;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStudent((prev) => ({ ...prev, [name]: value }));
  };

  const handleClassChange = (e) => {
    const { name, value } = e.target;
    if (name === "standard") {
      setStudent((prev) => ({
        ...prev,
        classRoomDTO: {
          ...prev.classRoomDTO,
          standard: value,
        },
      }))
    }

    setStudent((prev) => ({
      ...prev,
      classRoomDTO: { ...prev.classRoomDTO, [name]: value }
    }));

    if (name === "patternType" && value && !regex.pattern.test(value)) {
      setError("Please enter pattern type (STATE, CBSE, ICSE).");
      return;
    }

    if (name === "academicYear" && value && !regex.academicyear.test(value)) {
      setError("Please enter academic year (2024-2025).");
      return;
    }
  };

  const nextPage = () => setPages(pages + 1);
  const prevPage = () => setPages(pages - 1);

  // Pure check (does NOT set state) — used to enable/disable buttons in real time.
  const isSectionValid = (formFields, source = student) => {
    for (let field of formFields) {
      const value = source[field.name];

      if (isRequired(field) && (!value || value.toString().trim() === "")) {
        return false;
      }
      if (field.name === "phone" && value && !regex.mobile.test(value)) return false;
      if (field.name === "aadhaarNumber" && value && !regex.aadhaar.test(value)) return false;
      if (field.name === "apaarNumber" && value && !regex.aadhaar.test(value)) return false;
      if (field.name === "pincode" && value && !regex.pincode.test(value)) return false;
      if (field.name === "email" && value && !regex.email.test(value)) return false;
      if (field.name === "gender" && value && !regex.gender.test(value)) return false;
      if (field.name === "patternType" && value && !regex.pattern.test(value)) return false;
      if (field.name === "academicYear" && value && !regex.academicyear.test(value)) return false;
    }
    return true;
  };

  // Same rules as isSectionValid, but sets the error message + shows a Snackbar alert
  // (used when the user actually clicks Next/Submit).
  const validateFormSection = (formFields, source = student) => {
    for (let field of formFields) {
      const value = source[field.name];

      if (isRequired(field) && (!value || value.toString().trim() === "")) {
        showValidationError(`Please fill out the "${field.label}" field.`);
        return false;
      }

      if (field.name === "phone" && value && !regex.mobile.test(value)) {
        showValidationError("Please enter a valid 10-digit mobile number.");
        return false;
      }

      if (field.name === "aadhaarNumber" && value && !regex.aadhaar.test(value)) {
        showValidationError("Please enter a valid 12-digit Aadhaar number.");
        return false;
      }

      if (field.name === "pincode" && value && !regex.pincode.test(value)) {
        showValidationError("Please enter a valid 6-digit pincode.");
        return false;
      }

      if (field.name === "email" && value && !regex.email.test(value)) {
        showValidationError("Please enter a valid email address.");
        return false;
      }

      if (field.name === "gender" && value && !regex.gender.test(value)) {
        showValidationError("Please select gender (MALE, FEMALE, OTHER).");
        return false;
      }

      if (field.name === "patternType" && value && !regex.pattern.test(value)) {
        showValidationError("Please enter pattern type (STATE, CBSE, ICSE).");
        return false;
      }

      if (field.name === "academicYear" && value && !regex.academicyear.test(value)) {
        showValidationError("Please enter academic year (2024-2025).");
        return false;
      }
    }

    setError(null);
    return true;
  };

  const showValidationError = (message) => {
    setError(message);
    setSnackbar({ open: true, message, severity: 'error' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFormSection(form3, student.classRoomDTO)) return;

    student.schoolCode = userInfo?.mas_code;
    student.createdBy = userInfo?.sub;

    console.log('Student Registration Data:', student);
    onSubmit(student);
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const CustomConnector = (props) => (
    <StepConnector
      {...props}
      sx={{
        [`& .${stepConnectorClasses.line}`]: {
          borderColor: '#ccc',
          borderTopWidth: 3,
        },
        [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
          borderColor: '#1b1914',
        },
        [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
          borderColor: '#1b1914',
        },
      }}
    />
  );

  const renderForm = (formFields) => (
    <Grid display="flex" justifyContent="space-around" flexWrap={"wrap"}>
      {formFields.map(({ label, name, type = 'text', req = true }) => (
        <Grid item xs={12} sm={6} sx={{ width: '48%', my: 2 }} key={name}>
          <TextField
            fullWidth
            size={isMobile ? "small" : "medium"}
            required={req}
            variant="outlined"
            label={label}
            name={name}
            value={student[name]}
            onChange={handleChange}
            type={type}
            slotProps={type === 'date' && {
              inputLabel: { shrink: true }
            }}
          />
        </Grid>
      ))}
      <Typography sx={{ fontSize: '12px', color: 'red', mt: 1 }}>{error}</Typography>
    </Grid>
  );

  const renderClassForm = (formFields) => (
    <Grid display="flex" justifyContent="space-around" flexWrap="wrap">
      {formFields.map(({ label, name, type = 'text', req = true }) => (
        <Grid item xs={12} sm={6} sx={{ width: '48%', my: 2 }} key={name}>
          <TextField
            select={name === 'standard' ? true : false}
            fullWidth
            size={isMobile ? "small" : "medium"}
            required={req}
            variant="outlined"
            label={label}
            name={name}
            value={student.classRoomDTO[name]}
            onChange={type === 'number' ? null : handleClassChange}
            type={type}
            slotProps={type === 'date' && {
              inputLabel: { shrink: true }
            }}
          >
            {name === 'standard' &&
              feesStructures.map((fee) => (
                <MenuItem key={fee.id} value={fee.standard}>
                  {fee.standard}
                </MenuItem>
              ))}

          </TextField>
        </Grid>
      ))}

      <Typography sx={{ fontSize: '12px', color: 'red', mt: 1 }}>{error}</Typography>
    </Grid>
  );

  return (

    <Box sx={{ maxWidth: 800, margin: 0, p: 0 }}>
      {/* Stepper */}
      <Stepper activeStep={pages} alternativeLabel connector={<CustomConnector />} sx={{ mb: 2 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel slots={{ stepIcon: CustomStepIcon }}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Divider sx={{ mb: 4 }} />

      <form onSubmit={handleSubmit}>
        {pages === 0 && (
          <>
            {renderForm(form1)}
            <Box display="flex" justifyContent="flex-end">
              <Button
                onClick={() => { if (validateFormSection(form1)) nextPage(); }}
                variant="contained"
                disabled={!isSectionValid(form1)}
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6, backgroundColor: '#1b1914',
                  '&:hover': { backgroundColor: '#332a14ff' },
                  '&.Mui-disabled': { backgroundColor: '#cfcfcf' },
                }}
              >
                Next
              </Button>
            </Box>
          </>
        )}

        {pages === 1 && (
          <>
            {renderForm(form2)}
            <Box display="flex" justifyContent="space-between">
              <Button onClick={prevPage} variant="contained"
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6, backgroundColor: '#1b1914',
                  '&:hover': { backgroundColor: '#332a14ff' },
                }}
              >
                Prev
              </Button>
              <Button
                onClick={() => { if (validateFormSection(form2)) nextPage(); }}
                variant="contained"
                disabled={!isSectionValid(form2)}
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6, backgroundColor: '#1b1914',
                  '&:hover': { backgroundColor: '#332a14ff' },
                  '&.Mui-disabled': { backgroundColor: '#cfcfcf' },
                }}
              >
                Next
              </Button>
            </Box>
          </>
        )}

        {pages === 2 && (
          <>
            {renderClassForm(form3)}
            <Box display="flex" justifyContent="space-between">
              <Button onClick={prevPage} variant="contained"
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6, backgroundColor: '#1b1914',
                  '&:hover': { backgroundColor: '#332a14ff' },
                }}
              >
                Prev
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={!isSectionValid(form3, student.classRoomDTO)}
                sx={{
                  mt: 4, width: '40%', py: 1,
                  borderRadius: 6, backgroundColor: '#1b1914',
                  '&:hover': { backgroundColor: '#332a14ff' },
                  '&.Mui-disabled': { backgroundColor: '#cfcfcf' },
                }}
              >
                Submit
              </Button>
            </Box>
          </>
        )}
      </form>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default StudentRegister;
